import { Text } from "@theme/components";

interface FooterRegisteredProps {
  registeredSymbol: string;
}

export const FooterRegistered = ({ registeredSymbol }: FooterRegisteredProps) => (
  <Text
    variant="sansMicro02Regular"
    sx={{
      color: "grey300",
      textAlign: ["center", null, "left"],
    }}
  >
    {registeredSymbol}
  </Text>
);

export default FooterRegistered;
